/**
 * Scripts for handling Gutenberg blocks
 */

var $ = jQuery;

// One column block & multiple column block button auto alignment
$(document).ready(function() {

    $('.block-one-column, .block-multiple-columns .main-content-col').each(function() {
        var firstElCSS = $(this).find('.column-content *').first().css('text-align');

        if (firstElCSS.length) {
            $(this).find('.column-buttons').css('text-align', firstElCSS);
        }
    });

});

// Contact block "tel:"" link buttonizing
$(document).ready(function() {

    $('.block-contact-information .column-content a[href^="tel:"]').each(function() { 
        $(this).addClass('button button-small');
    });

});

// Block auto alignment
$(document).ready(function() {

	/**
	 * First block in content auto spacing
	 */
    var first = $('.page-content > *, .article-content > *').first();
    if (!first.hasClass('block')) {
        first.addClass('pt-5 pt-xl-6');
    }

	/**
	 * Last block in content auto spacing
	 */
    var last = $('.page-content > *, .article-content > *').last();
	if (!last.hasClass('block')) {
        last.addClass('pb-5 pb-xl-6');
    }

	/**
	 * Block auto spacing 
	 */

	$('.block').each(function() { // custom block class

		if ($(this).hasClass('block-graphic')) { // graphic block

			/** 
			 * Add margin to blocks next and previous to this block
			 */			

			var next = $(this).next();
			
			if (!next.hasClass('block')) {
				next.addClass('pt-5 pt-xl-6');
			}

		} else {

			/** 
			 * Do the same as above but with removing padding 
			 *
			 * Check for bg class we dont want to remove all
			 * padding from subsequent main content blocks
			 */

			var prev = $(this).prev();
			var next = $(this).next();

			if (next.hasClass('block') && !next.hasClass('has-bg')) {
				$(this).attr('style', 'padding-bottom: 15px !important');
			}
		}

	});

});